import { FETCH_BRAND } from "../actions/brandActions";

const initState = {};

const brandReducer = (state = initState, action) => {
    if (action.type === FETCH_BRAND) {
        // Replace, not merge — see rootPageReducer.
        return {
            ...action.payload,
        };
    }

    return state;
};

export default brandReducer;
